<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <button
                class="action-btn action-btn-create mb-3"
                (click)="openModalAdd()">
                <i-feather name="plus" class="feather-base"></i-feather>
                Add Approver Setup
            </button>
            <div class="form-group row mb-3">
                <div class="col-md-2">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-2">
                    <ng-select (change)="onChangePeriod($event)"
                        [items]="periodList"
                        bindLabel="name"
                        bindValue="period_id"
                        placeholder="Select period"
                        class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">{{item.name}}</div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-2">
                    <app-select-school-level-relation-v2
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event)"
                        [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-2">
                    <ng-select (change)="onChangeYearLevel($event)"
                        [items]="yearLevelRelations"
                        bindLabel="description"
                        bindValue="year_level_id"
                        placeholder="Select year level"
                        class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.description }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select (change)="onChangeModule($event)"
                        [items]="setupList"
                        bindValue="approver_setup_id"
                        bindLabel="module_name"
                        placeholder="Select module"
                        class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.module_name }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="margin-top:70px">
                <mat-spinner></mat-spinner>
            </div>
            <div>
                <app-status-no-data [show]="data.length === 0 && !loading"></app-status-no-data>
            </div>
            <div class="table-responsive">
                <table mat-table *ngIf="data.length > 0 && !loading"
                       [dataSource]="data" multiTemplateDataRows
                       >
                    <ng-container matColumnDef="module_name">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'MODULE_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.module_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="year-period">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> Year-Period </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.academic_year || '-'}} - {{element.period_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="year_level">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> Level-Location </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.year_level_name || '-'}} - {{element.school_short_address || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'ROLE_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.role_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fullname">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'FULLNAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.fullname || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center"> {{ 'ACTIONS' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div class="d-flex justify-content-center gap-1">
                                <button
                                    class="action-icon-btn action-icon-edit"
                                    (click)="openModalEdit(element.approver_setup_setting_id)"
                                    [title]="'EDIT' | translate">
                                    <div>
                                        <i-feather name="edit-2" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button
                                    class="action-icon-btn action-icon-delete"
                                    (click)="onDelete(element.approver_setup_setting_id)"
                                    [title]="'DELETE' | translate">
                                    <div>
                                        <i-feather name="trash-2" class="feather-base"></i-feather>
                                    </div>
                                </button>
                            </div>

                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #addSetup let-modal let-close="close">
    <div class="p-4">
        <form (ngSubmit)="onAdd()" [formGroup]="newForm">
            <b>Add Approver Setup</b>
            <div class="form-group mb-3 ms-4 mt-3">
                <div class="row mb-4">
                    <app-select-academic-year-only
                        class="col-md-4 p-0"
                        (academicYearChanged)="onChangeAcademicYear($event, 'add')">
                    </app-select-academic-year-only>
                </div>
                <div class="row mb-4">
                    <ng-select (change)="onChangePeriod($event, 'add')"
                        [items]="periodList"
                        bindLabel="name"
                        bindValue="period_id"
                        formControlName="period_id"
                        placeholder="Select period"
                        class="selector-style col-md-4">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">{{item.name}}</div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="row mb-4">
                    <app-select-school-level-relation-v2
                        class="col-md-4 p-0"
                        [academic_year]="this.newForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event, 'add')"
                        [isDisabled]="!this.newForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="row mb-4">
                    <div>Year level</div>
                    <div class="d-grid col-md-5" *ngIf="!this.newForm.controls['school_location_id']?.value">
                        <i>{{ 'PLEASE_SELECT_ACADEMIC_YEAR_AND_SCHOOL_LEVEL' | translate }}</i>
                    </div>
                    <div class="row" *ngIf="this.newForm.controls['school_location_id']?.value">
                        <div *ngFor="let year of yearLevelRelations" class="col-md-4">
                            <mat-checkbox mat-checkbox (change)="onChangeYearLevelByCheckbox($event, year)">
                                {{ year.description }}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <ng-select (change)="onChangeRole($event, 'add')"
                        [items]="roleList"
                        placeholder="Select role"
                        bindValue="role_id"
                        bindLabel="role_name"
                        formControlName="role_id"
                        class="selector-style col-md-4">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.role_name }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="row mb-4">
                    <ng-select (change)="onChangeUser($event, 'add')"
                        [items]="userList"
                        placeholder="Select user"
                        bindValue="user_id"
                        bindLabel="fullname"
                        class="selector-style col-md-4"
                        formControlName="user_id">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.fullname }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="row mb-4">
                    <ng-select (change)="onChangeModule($event, 'add')"
                        [items]="setupList"
                        bindValue="approver_setup_id"
                        bindLabel="module_name"
                        formControlName="approver_setup_id"
                        placeholder="Select module"
                        class="selector-style col-md-6">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.module_name }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <button type="button" class="gradient-button col-md-2 mt-3 me-1" (click)="onCloseModal()">Cancel</button>
                <button type="submit" class="gradient-button col-md-2 mt-3 me-1" [disabled]="newForm.invalid">Save</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #editSetup let-modal let-close="close">
    <div class="p-4" *ngIf="showEditModal">
        <b>Edit Approver Setup</b>
        <form [formGroup]="editForm">
            <div class="form-group mb-3 ms-4 mt-3" *ngIf="detailData && roleList.length > 0">
                <div class="row mb-4">
                    <div class="selector-stylev2 col-md-4">
                        {{ detailData.academic_year || '-' }}
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="selector-stylev2 col-md-4">
                        {{ detailData.school_short_address || '-' }}
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="selector-stylev2 col-md-4">
                        {{ detailData.year_level_name || '-' }}
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="selector-stylev2 col-md-4">
                        {{ detailData.module_name || '-' }}
                    </div>
                </div>
                <div class="row mb-4">
                    <ng-select (change)="onChangeRole($event, 'edit')"
                        [items]="roleList"
                        placeholder="Select role"
                        bindValue="role_id"
                        bindLabel="role_name"
                        class="selector-style col-md-4"
                        formControlName="role_id">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.role_name }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="row mb-4">
                    <ng-select (change)="onChangeUser($event, 'edit')"
                        [items]="userList"
                        placeholder="Select user"
                        bindValue="user_id"
                        bindLabel="fullname"
                        class="selector-style col-md-4"
                        formControlName="user_id">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.fullname }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-between">
            <button type="button" class="gradient-button col-md-2 mt-3 me-1" (click)="onCloseModal()">Cancel</button>
            <button type="submit" class="gradient-button col-md-2 mt-3 me-1" (click)="onEdit()" [disabled]="editForm.invalid">Save</button>
        </div>
    </div>
</ng-template>
